import { useAuth } from "react-oidc-context";
import { useMemo } from "react";
import { useUser } from "../context/UserContext";

export const usePermissions = () => {
  const auth = useAuth();
  const { user } = useUser();

  const permissions = useMemo(() => {
    if (!auth.isAuthenticated || !auth.user) {
      return {
        isAdmin: false,
        isSeller: false,
        groups: [],
        storeId: null,
        isStoreAdmin: false,
        canManageStores: false,
        canManageUsers: false,
        canViewReports: false
      };
    }

    const userGroups = auth.user?.profile?.['cognito:groups'] || [];
    const isAdmin = userGroups.includes('Admin');
    const isSeller = userGroups.includes('Seller');
    
    return {
      isAdmin,
      isSeller,
      groups: userGroups,
      storeId: user?.storeId || null,
      isStoreAdmin: user?.isStoreAdmin || false,
      canManageStores: isAdmin,
      canManageUsers: isAdmin,
      canViewReports: isAdmin || userGroups.includes('Manager')
    };
  }, [auth.isAuthenticated, auth.user, user?.storeId, user?.isStoreAdmin]);

  return permissions;
};